/* eslint-disable no-undef */
/**
 * BESIKOS CARS — minimal car.gr bookmarklet
 *
 * Architecture: the bookmarklet itself is intentionally tiny (~500 chars after compaction).
 * It collects the page HTML and POSTs it to the BESIKOS server, which does ALL the
 * heavy parsing in Python (more reliable than browser-side JS) and then 303-redirects
 * the dealer to /cars/new?cargr=... with the form pre-filled.
 *
 * Benefits over the previous all-inline approach:
 *  - URL stays under 1KB → never truncated by Chrome/Firefox bookmark stores
 *  - Server-side parsing can be updated without re-dragging the bookmark
 *  - Cross-origin form POST is allowed by car.gr's CSP (`form-action http: https:`)
 */
export const BOOKMARKLET_TEMPLATE = (targetHost) => {
  const TARGET = JSON.stringify(targetHost);
  return `(function(){
try {
  var t = document.createElement('div');
  t.style.cssText = 'position:fixed;top:20px;right:20px;z-index:2147483647;padding:14px 20px;background:#0A0A0A;color:#fff;font:bold 14px system-ui;border-left:4px solid #10b981;box-shadow:0 4px 20px rgba(0,0,0,.3)';
  t.textContent = 'BESIKOS · Αποστολή σε server...';
  document.body.appendChild(t);
  var f = document.createElement('form');
  f.method = 'POST';
  f.action = ${TARGET} + '/api/import/cargr-from-browser';
  f.target = '_blank';
  f.enctype = 'multipart/form-data';
  f.style.display = 'none';
  var b64 = function(s){ return btoa(unescape(encodeURIComponent(s))); };
  var h = document.createElement('input');
  h.type = 'hidden'; h.name = 'html_b64'; h.value = b64(document.documentElement.outerHTML);
  f.appendChild(h);
  var u = document.createElement('input');
  u.type = 'hidden'; u.name = 'url'; u.value = location.href;
  f.appendChild(u);
  try {
    var v = window.__NUXT__ && window.__NUXT__.state && window.__NUXT__.state.classifieds && window.__NUXT__.state.classifieds.view;
    if (v && v.classified) {
      var n = document.createElement('input');
      n.type = 'hidden'; n.name = 'nuxt_b64'; n.value = b64(JSON.stringify({classified: v.classified}));
      f.appendChild(n);
    }
  } catch (e2) {}
  document.body.appendChild(f);
  f.submit();
  setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 2000);
} catch (err) {
  alert('BESIKOS bookmarklet error: ' + (err && err.message ? err.message : err));
}
})();`;
};

/**
 * Sync bookmarklet v2 — run on the dealer storefront (https://besikoscars.car.gr/).
 * Reads ALL pages of the storefront (fetch ?pg=2..15 from within the browser,
 * which passes Cloudflare), extracts every listing (id, slug, card text) and
 * POSTs them to the backend for matching against fleet cars.
 */
export const SYNC_BOOKMARKLET_TEMPLATE = (targetHost) => {
  const TARGET = JSON.stringify(targetHost);
  return `(function(){
try {
  var t = document.createElement('div');
  t.style.cssText = 'position:fixed;top:20px;right:20px;z-index:2147483647;padding:14px 20px;background:#0A0A0A;color:#fff;font:bold 14px system-ui;border-left:4px solid #0055FF;box-shadow:0 4px 20px rgba(0,0,0,.3)';
  t.textContent = 'BESIKOS · Συλλογή αγγελιών...';
  document.body.appendChild(t);
  var seen = {};
  var collect = function(doc){
    var added = 0;
    var as = doc.querySelectorAll('a[href*="/view/"]');
    for (var i = 0; i < as.length; i++) {
      var href = as[i].getAttribute('href') || '';
      var m = href.match(/\\/view\\/(\\d+)(-[a-z0-9-]*)?/i);
      if (!m) continue;
      var id = m[1];
      var card = as[i].closest('article,li') || as[i];
      var txt = ((card.innerText || card.textContent || '') + ' ').replace(/\\s+/g, ' ').slice(0, 400);
      if (!seen[id]) {
        seen[id] = { id: id, slug: (m[2] || '').replace(/^-/, ''), text: txt };
        added++;
      } else if (txt.length > (seen[id].text || '').length) {
        seen[id].text = txt;
      }
    }
    return added;
  };
  collect(document);
  var fetchPage = function(pg){
    return fetch(location.pathname + '?pg=' + pg, { credentials: 'same-origin' }).then(function(r){
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function(html){
      return collect(new DOMParser().parseFromString(html, 'text/html'));
    });
  };
  var chain = Promise.resolve();
  var stop = false;
  for (var pg = 2; pg <= 15; pg++) {
    (function(p){
      chain = chain.then(function(){
        if (stop) return;
        t.textContent = 'BESIKOS · Σελίδα ' + p + '... (' + Object.keys(seen).length + ' αγγελίες)';
        return fetchPage(p).then(function(added){
          if (added === 0) stop = true;
        }).catch(function(){ stop = true; });
      });
    })(pg);
  }
  chain.then(function(){
    var list = Object.keys(seen).map(function(k){ return seen[k]; });
    t.textContent = 'BESIKOS · Αποστολή ' + list.length + ' αγγελιών...';
    var f = document.createElement('form');
    f.method = 'POST';
    f.action = ${TARGET} + '/api/import/cargr-dealer-sync';
    f.target = '_blank';
    f.enctype = 'multipart/form-data';
    f.style.display = 'none';
    var b64 = function(s){ return btoa(unescape(encodeURIComponent(s))); };
    var add = function(name, val){
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = val;
      f.appendChild(i);
    };
    add('listings_b64', b64(JSON.stringify(list)));
    add('url', location.href);
    try {
      var st = window.__NUXT__ && window.__NUXT__.state && window.__NUXT__.state.classifieds;
      if (st) {
        var s = JSON.stringify(st);
        if (s && s.length < 3000000) { add('nuxt_b64', b64(s)); }
      }
    } catch (e2) {}
    document.body.appendChild(f);
    f.submit();
    setTimeout(function(){ if (t.parentNode) t.parentNode.removeChild(t); }, 3000);
  });
} catch (err) {
  alert('BESIKOS sync error: ' + (err && err.message ? err.message : err));
}
})();`;
};
